import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { reduxKey } from './constants';
import get from 'lodash/get';
import { createSelector } from 'reselect';
const getWatchSlice = (state)=>state[reduxKey];
export const getWatchState = createSelector(getWatchSlice, (state, username)=>username, (state, username)=>{
    return username ? state[username.toLowerCase()] : {};
});
export function getIsInitialized(state, username) {
    return Boolean(username) && state[reduxKey] !== undefined && state[reduxKey][username.toLowerCase()] !== undefined;
}
export const getUserWatchState = createSelector((state)=>state, (state, user)=>user, (state, initialState)=>initialState, (state, user, initialState)=>{
    var _initialState;
    const username = get(user, 'username');
    var _initialState_isWatching, _ref;
    const initialIsWatching = (_ref = (_initialState_isWatching = (_initialState = initialState) === null || _initialState === void 0 ? void 0 : _initialState.isWatching) !== null && _initialState_isWatching !== void 0 ? _initialState_isWatching : get(user, 'isWatching')) !== null && _ref !== void 0 ? _ref : false;
    if (!username) {
        return {
            isWatching: initialIsWatching,
            isLoading: false
        };
    }
    const userState = getWatchState(state, username);
    return _object_spread({
        isWatching: initialIsWatching,
        isLoading: false
    }, userState);
});
